import {ajax} from '../../utils/ajax';

export function getFoodList(){
    return ajax('tokenJson', '/kitchen/foods', 'GET', false)
}

export function getFoodPlans(page){
    return ajax('tokenJson', '/kitchen/foods/getPlans?page=' + page, 'GET', false)
}

export function joinToProgram(planId){
    return ajax('tokenJson', '/kitchen/foods/join', 'POST', true, {planId: planId})
}

export function removeFromPlan(planId){
    return ajax('tokenJson', '/kitchen/foods/removeFromPlan', 'POST', true, {planId: planId})
}

export function addNewPlan(foodId, date){
    return ajax('tokenJson', '/kitchen/foods/submitPlan', 'POST', true, {foodId: foodId, date: date})
}
export function removePlan(planId){
    return ajax('tokenJson', '/kitchen/foods/removePlan', 'POST', true, {planId: planId})
}

export function usersOnPlan(planId){
    return ajax('tokenJson', '/kitchen/foods/UsersOnPlan', 'POST', true, {planId: planId})
}
